import { ApiEndpoints } from "@shared/api/api-endpoints";
import {
  bxApiClient,
  communicationApiClient,
} from "@shared/api/clients/apiClientFactory";
import { QueryStringParameters } from "@shared/api/url-builder";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

export const downloadBillTemplate = async (billId: string): Promise<Blob> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    // `render-new-dynamic-component-template/${billId}`
    `render-dynamic-template/${billId}`,
  );
  const response = await bxApiClient.get(url, {
    responseType: "blob",
  });
  return response.data;
};

export const getBillCorrectionDetails = async (
  remoteUtilityId: string,
  correctionId: string,
): Promise<any> => {
  const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
    "bx",
    `bill-correction`,
    [correctionId, "detail"],
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", remoteUtilityId);
    },
  );
  const response = await bxApiClient.get(url);
  return response.data;
};

export const getBillPreview = async (draftId: number): Promise<any> => {
  const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
    "bx",
    "single-bill",
    [draftId, "render-bill"],
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", getRemoteUtilityId());
    },
  );

  const response = await bxApiClient.get(url, {
    responseType: "blob",
  });
  return response.data;
};

export const getTemplates = async (
  channelType: string,
  remoteUtilityId: string,
): Promise<any[]> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "communication",
    "get-templates",
    (query) => {
      query.push("remote_utility_id", remoteUtilityId);
      query.push("channel_type", channelType);
      query.push("is_active", 1);
    },
  );

  const response = await communicationApiClient.get(url);
  return response?.data?.result;
};

export const sendCommunication = async (data: any): Promise<any> => {
  const response = await communicationApiClient.post(
    ApiEndpoints.createUrl("communication", "direct-message"),
    data,
  );
  return response.data;
};
